import React, { FC, ReactNode } from 'react';
import { useDroppable } from '@dnd-kit/core';

interface DroppableBlankI {
  id: string;
  style?: React.CSSProperties;
  children: ReactNode;
}

/**
 * Lightweight droppable wrapper for hybrid (type + drag) fill-in-the-blank inputs.
 *
 * Unlike DroppableContainer it puts the dnd-kit droppable ref directly on the
 * wrapping div instead of an absolutely-positioned overlay. That keeps the
 * inline layout intact and avoids covering the text input, so the field stays
 * clickable/typeable while still acting as a drop target for word-bank items.
 */
export const DroppableBlank: FC<DroppableBlankI> = ({ id, style, children }) => {
  const { setNodeRef } = useDroppable({
    id,
    data: {
      accepts: 'WORD_BANK',
    },
  });

  return (
    <div ref={setNodeRef} id={id} style={style}>
      {children}
    </div>
  );
};
